import React from "react";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import img3 from "../../assets/images/blog/case-studie-img-3.webp";
import img4 from "../../assets/images/blog/case-studie-img-4.webp";
import img5 from "../../assets/images/blog/case-studie-img-5.webp";
import img6 from "../../assets/images/blog/case-studie-img-6.webp";
import { NavLink } from "react-router-dom";

function Categories() {

  return (
    <>
      <section className="categories-section" id="CaseStudy"></section>
      <section className="case-studie-sec case-sec2" id="explore">
        <div className="container">
            <div className="studie-details">
              <div className="left">
                <div className="img-card">
                  <img
                    src={img3}
                    alt={"Case Studie"}
                    className="img-fluid"
                    width={468}
                    height={381}
                  />
                </div>
              </div>
              <div className="right">
                <div className="content-details">
                  <h3>
                  Enhancing Logistics Efficiency with Choice Touch
                  </h3>
                  <p>
                  The logistics industry faces significant challenges, including complex supply chain management,
                  fluctuating demand, regulatory compliance, and maintaining customer satisfaction.
                  </p>
                  <NavLink to="/enhance-logistics-efficiency-and-customer-satisfaction-with-choice-touch" className="btn border-btn">
                    Read Case Study
                  </NavLink>
                </div>
              </div>
            </div>
        </div>
      </section>
      <section className="categories-section" id="CaseStudy"></section>
      <section className="case-studie-sec case-sec2">
        <div className="container">
            <div className="studie-details col-revers">
              <div className="left">
                <div className="img-card">
                  <img
                    src={img4}
                    alt={"Case Studie"}
                    className="img-fluid"
                    width={468}
                    height={381}
                  />
                </div>
              </div>
              <div className="right">
                <div className="content-details">
                  <h3>
                  Streamlining Expense Management in the Manufacturing Industry with Prime
                  </h3>
                  <p>
                  ABC Manufacturing is a leading player in the manufacturing sector, facing challenges in
managing expenses effectively. To address these challenges and improve operational efficiency, ABC
implements Choice Prime, an integrated business management solution.
                  </p>
                  <NavLink to="/streamlining-expense-managment-in-manufacturing-with-prime" className="btn border-btn">
                    Read Case Study
                  </NavLink>
                </div>
              </div>
            </div>
        </div>
      </section>
      <section className="categories-section" id="CaseStudy"></section>
      <section className="case-studie-sec case-sec2">
        <div className="container">
            <div className="studie-details">
              <div className="left">
                <div className="img-card">
                  <img
                    src={img5}
                    alt={"Case Studie"}
                    className="img-fluid"
                    width={468}
                    height={381}
                  />
                </div>
              </div>
              <div className="right">
                <div className="content-details">
                  <h3>
                  Enhancing customer experience in insurance with welcome calls via Greetly
                  </h3>
                  <p>
                  ABC Insurance Co. is a leading insurance provider having a wide range of
insurance products; life, health, and property insurance.
                  </p>
                  <NavLink to="/enhancing-customer-experience-with-greetly" className="btn border-btn">
                    Read Case Study
                  </NavLink>
                </div>
              </div>
            </div>
        </div>
      </section>
      <section className="categories-section" id="CaseStudy"></section>
      <section className="case-studie-sec case-sec2">
        <div className="container">
            <div className="studie-details col-revers">
              <div className="left">
                <div className="img-card">
                  <img
                    src={img6}
                    alt={"Case Studie"}
                    className="img-fluid"
                    width={468}
                    height={381}
                  />
                </div>
              </div>
              <div className="right">
                <div className="content-details">
                  <h3>
                  Optimizing Supply Chain Management with Prime
                  </h3>
                  <p>
                  ABC FMCG Corporation, a global player in the FMCG industry, faced challenges in managing its supply
chain efficiently due to its extensive network spanning multiple regions.
                  </p>
                  <NavLink to="/enhancing-supply-chain-efficiency-with-prime" className="btn border-btn">
                    Read Case Study
                  </NavLink>
                </div>
              </div>
            </div>
        </div>
      </section>
    </>
  );
}

export default Categories;
